import { useEffect, useRef, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Download, Menu, X } from "lucide-react";
import { downloadAPK } from "../../Helpers/DownloadAPK";
import headerLog from "../../../RichImages/nav-logo-main.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

  const navClass = ({ isActive }) =>
    `tw-font-medium tw-transition-colors tw-no-underline ${
      isActive
        ? "tw-text-[#1e6ebe] tw-border-b-2 tw-border-[#1e6ebe]"
        : "tw-text-gray-700 hover:tw-text-[#1e6ebe]"
    }`;

  const simpleLink =
    "tw-font-medium tw-text-gray-700 hover:tw-text-[#1e6ebe] tw-no-underline";

  const mobileNavClass = ({ isActive }) =>
    `tw-py-2 tw-font-medium tw-no-underline ${
      isActive
        ? "tw-text-[#1e6ebe] tw-bg-blue-50 tw-rounded-md"
        : "tw-text-gray-700 hover:tw-text-[#1e6ebe]"
    }`;

  return (
    <nav
      className="tw-shadow-sm tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-50 tw-bg-[#f2feff]"
      ref={navRef}
    >
      {/* Animation */}
      <style>{`
        @keyframes floatBounce {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-6px); }
        }
        .download-btn {
          animation: floatBounce 2.5s ease-in-out infinite;
          transition: all 0.3s ease;
        }
        .download-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 0 20px rgba(1, 161, 164, 0.5);
          animation-play-state: paused;
        }
      `}</style>

      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 md:tw-px-12">
        <div className="tw-flex tw-items-center tw-justify-between tw-h-16 md:tw-h-20">
          {/* Logo */}
          <NavLink to="/" className="tw-flex tw-items-center">
            <img
              src={headerLog}
              alt="Laksh365"
              className="tw-h-8 md:tw-h-10 tw-w-auto"
            />
          </NavLink>

          {/* Desktop Nav */}
          <div className="tw-hidden lg:tw-flex tw-items-center tw-gap-8">
            <NavLink to="/charts" className={navClass}>
              Charts
            </NavLink>

            {/* scroll links — no active state */}
            <Link to="/" state={{ scrollTo: "rates" }} className={simpleLink}>
              Rates
            </Link>

            <Link
              to="/"
              state={{ scrollTo: "markets" }}
              className={simpleLink}
            >
              Markets
            </Link>

            <NavLink to="/about-us" className={navClass}>
              About Us
            </NavLink>
            <NavLink to="/how-to-play" className={navClass}>
              How To Play
            </NavLink>
          </div>

          {/* Desktop Download */}
          <div className="tw-hidden lg:tw-block">
            <button
              onClick={download}
              className="download-btn tw-bg-gradient-to-br tw-from-blue-600 tw-to-blue-800 hover:tw-from-blue-700 hover:tw-to-blue-900 tw-text-white tw-font-semibold tw-px-6 tw-py-2.5 tw-rounded-lg tw-flex tw-items-center tw-gap-2"
            >
              <Download className="tw-w-4 tw-h-4 tw-animate-bounce" />
              Download App
            </button>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            className="lg:tw-hidden tw-p-2"
          >
            {isOpen ? (
              <X className="tw-w-6 tw-h-6" />
            ) : (
              <Menu className="tw-w-6 tw-h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:tw-hidden tw-py-4 tw-border-t">
            <div className="tw-flex tw-flex-col tw-gap-4">
              <NavLink
                to="/charts"
                onClick={() => setIsOpen(false)}
                className={mobileNavClass}
              >
                Charts
              </NavLink>

              <Link
                to="/"
                state={{ scrollTo: "rates" }}
                onClick={() => setIsOpen(false)}
                className={simpleLink}
              >
                Rates
              </Link>

              <Link
                to="/"
                state={{ scrollTo: "markets" }}
                onClick={() => setIsOpen(false)}
                className={simpleLink}
              >
                Markets
              </Link>

              <NavLink
                to="/about-us"
                onClick={() => setIsOpen(false)}
                className={mobileNavClass}
              >
                About Us
              </NavLink>

              <NavLink
                to="/how-to-play"
                onClick={() => setIsOpen(false)}
                className={mobileNavClass}
              >
                How To Play
              </NavLink>

              <button
                onClick={(e) => {
                  download(e);
                  setIsOpen(false);
                }}
                className="download-btn tw-bg-gradient-to-br tw-from-blue-600 tw-to-blue-800 tw-text-white tw-font-semibold tw-px-6 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-2"
              >
                <Download className="tw-w-4 tw-h-4 tw-animate-bounce" />
                Download App
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;